<template>
  <div class="modify_">
    <div class="mo_con_">
      <div class="title_">
        人员清单
      </div>
      <div class="page_ table_textc gdMange_">
        <div class="tip_" style="display:none">
          提示：多个用户或身份证请用（，）隔开。例如：张三，李四，王五
        </div>
        <div class="tip_" v-if="!ifEditable">
          提示:该保单已生效，不支持保全
        </div>
        <div>
          <a-form layout="inline">
            <a-form-item style="opacity:0">
              <a-input class="min_input_" style="width: 138px;" v-model="name" placeholder="请输入姓名"></a-input>
            </a-form-item>
            <a-form-item style="opacity:0">
              <a-input class="min_input_" style="width: 178px;" placeholder="请输入证件号码" v-model="idNumber"></a-input>
            </a-form-item>
            <a-form-item style="opacity:0">
              <a-button type="primary" @click="searchData()">查询</a-button>
              <a-button style="margin-left: 8px;" type="primary" ghost @click="initData()">重置</a-button>
            </a-form-item>
            <a-form-item style="float:right;margin-right: 0;">
              <a-upload name="file" :multiple="true" :before-upload="beforeUpload" :customRequest="beforeUpload"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                class="btn_upload" :disabled="operateType==='00'">
                <span style="color:#F5692C;">批量新增</span>
              </a-upload>
              <a-upload name="file" :multiple="true" :before-upload="beforeUpload1" :customRequest="beforeUpload1"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                class="btn_upload" :disabled="operateType==='01'">
                <span style="color:#F5692C;">批量删除</span>
              </a-upload>
              <a-button style="margin-left: 8px;" type="primary" ghost @click="showStickMask">粘贴名单</a-button>
              <a-button style="margin-left: 8px;" type="primary" ghost><a
                  href="http://cps.run4wd.com/pcmall/Insured_Template_xdlxx.xls" download>下载人员模板（批增）</a></a-button>
              <a-button style="margin-left: 8px;" type="primary" ghost><a
                  href="http://cps.run4wd.com/pcmall/template_sub.xls" download></a>下载人员模板（批减）</a></a-button>
            </a-form-item>
          </a-form>
        </div>
        <a-table style="margin-top: 17px;" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :columns="columns" :dataSource="data" :pagination="pagination" class="table_b table_nowrap">
          <span slot="gender" slot-scope="text, record, index">
            <span :style="`${record.sexErr ? 'color:red' : ''}`">{{ text | filters(genderOptions)}}</span>
          </span>
          <span slot="idType" slot-scope="text, record, index">
            <span>{{ text | filters(idTypeOptions)}}</span>
          </span>
          <span slot="operateType" slot-scope="text, record, index">
            <span>{{ text | filters(operateTypeOptions)}}</span>
          </span>
          <span slot="idNumber" slot-scope="text, record, index">
            <span :style="`${record.idcardInvalid ? 'color:red' : ''}`">{{ text}}</span>
          </span>
          <template slot="footer" slot-scope="currentPageData">
            <a-row class="foot_">
              <a-col :span="12" class="left_">
                <a @click="restore">
                  <img src="../../../assets/gd/reback.png" alt="" />
                  <span>还原</span>
                </a>
                <a @click="AddOne">
                  <img src="../../../assets/gd/add.png" alt="" />
                  <span>新增</span>
                </a>
                <a @click="deleteSelect">
                  <img src="../../../assets/gd/del.png" alt="" />
                  <span>删除</span>
                </a>
                <a @click="cancelAdd">
                  <img src="../../../assets/gd/add.png" alt="" />
                  <span>取消新增</span>
                </a>
                <a @click="cancelDelete">
                  <img src="../../../assets/gd/del.png" alt="" />
                  <span>取消删除</span>
                </a>
              </a-col>
              <a-col :span="12" class="pagina_">
                <a-pagination show-quick-jumper :page-size="pagination.pageSize" :total="pagination.total"
                  @change="handlePageChange" />
                <div class="li_v_"></div>
                <span class="total_">共{{ pagination.total }}条</span>
              </a-col>
            </a-row>
          </template>
        </a-table>
        <!-- 增减弹框 -->
        <a-modal wrapClassName="forModal_" v-model="formVisible" title="被保险人信息" :footer="null">
          <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
            <a-row>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="姓名">
                  <a-input v-decorator="[
                      'name',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入姓名',
                          },
                        ],
                      },
                    ]" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="证件类型">
                  <a-select v-decorator="[
                      'idType',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请选择证件类型',
                          },
                        ],
                      },
                    ]" placeholder="请选择证件类型" @change="(value,option) =>handleTypeChange(value,option)">
                    <a-select-option v-for="(item, index) in idTypeOptions" :key="index" :value="item.value">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="证件号码">
                  <a-input v-decorator="[
                      'idNumber',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请输入证件号码',
                          },
                        ],
                      },
                    ]" @blur="(e) => validate(e.target.value)" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="性别">
                  <a-select v-decorator="[
                      'gender',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请选择性别',
                          },
                        ],
                      },
                    ]" placeholder="请选择性别" @change="genderChange">
                    <a-select-option value="M">
                      男
                    </a-select-option>
                    <a-select-option value="F">
                      女
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="出生日期">
                  <a-date-picker style="width:220px" v-decorator="[
                      'birthDate',
                      {
                        rules: [
                          {
                            type: 'object',
                            required: true,
                            message: '请选择时间',
                          },
                        ],
                      },
                    ]" :disabledDate="handledisabledDate"
                    @change="(date,dateString)=>handleDateChange(date,dateString)" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="手机号:">
                  <a-input v-decorator="[
                      'mobile',
                      {
                        rules: [],
                      },
                    ]" @blur="(e)=>mobileChange(e.target.value)" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item v-bind="formItemLayout" label="份数:">
                  <a-select v-decorator="[
                      'purchaseNumber',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请选择份数',
                          },
                        ],
                      },
                    ]" placeholder="请选择份数">
                    <a-select-option value="1">
                      1
                    </a-select-option>
                    <a-select-option value="2">
                      2
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="24" style="text-align: right;">
                <a-form-item>
                  <a-button type="primary" html-type="submit" style="margin-right:20px;">
                    保存
                  </a-button>
                  <a-button type="primary" @click="formVisible = false">
                    关闭
                  </a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-modal>

        <!-- 粘贴名单 -->
        <a-modal class="myModal_" width="1021px" title="粘贴名单数据" forceRender v-model="visibleStick"
          @ok="handleStick('01')" okText="批增" cancelText="关闭">
          <div class="flex_">
            <span :style="{ color: 'red' }">*</span>
            <div>
              字段与字段直接用空格隔开，时间格式支持2018-01-01或2018/01/01。
            </div>
          </div>
          <div style="margin-bottom: 8px;padding-left: 6px;">
            例如：张三 居民身份证 110101198001010061 1980-01-01 女 18852981993 2
          </div>
          <textarea v-model="stickData" name="stickArea" id="stickArea" cols="30" rows="12"
            :style="{ width: '100%' }"></textarea>
          <a-button class="btn_model" @click="handleStick('00')">批减</a-button>
        </a-modal>
        <!-- 粘贴名单 -->

        <div class="footer_">
          <span>
            本次减员：<span class="theme_">{{ minusMember }}人</span>
          </span>
          <span>
            本次增员：<span class="theme_">{{ addMember }}人</span>
          </span>
          <span>
            原在保人数：<span class="theme_">{{ oldNumber }}人</span>
          </span>
          <span>
            保费变化：<span class="theme_">{{ premiumChange }}元</span>
          </span>
        </div>
        <div class="btn_b">
          <a-button type="primary" style="margin-right:10px;" @click="saveChange" :disabled="ifEditable?false:true">生成批单
          </a-button>
          <!-- <a-button type="primary" style="margin-right:10px;"
            >批改记录</a-button
          > -->
          <a-button type="primary" @click="reback" ghost>关闭</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import api from "@/utils/api";
  import dictOptions from "./dictOptions";
  import checkIdCard from "./checkIdCard";
  const columns = [{
      title: "姓名",
      key: "name",
      dataIndex: "name",
      width: 150,
    },
    {
      title: "证件类型",
      key: "idType",
      dataIndex: "idType",
      width: 150,
      scopedSlots: {
        customRender: "idType"
      },
    },
    {
      title: "证件号码",
      key: "idNumber",
      dataIndex: "idNumber",
      scopedSlots: {
        customRender: "idNumber"
      },
      width: 200,
    },
    {
      title: "出生日期",
      key: "birthDate",
      dataIndex: "birthDate",
      width: 150,
    },
    {
      title: "性别",
      key: "gender",
      dataIndex: "gender",
      width: 90,
      scopedSlots: {
        customRender: "gender"
      },
    },
    {
      title: "手机号",
      key: "mobile",
      dataIndex: "mobile",
      width: 150,
    },
    {
      title: "份数",
      key: "purchaseNumber",
      dataIndex: "purchaseNumber",
      width: 90,
    },
    {
      title: "批改类型",
      key: "operateType",
      dataIndex: "operateType",
      scopedSlots: {
        customRender: "operateType"
      },
      width: 90,
    },
  ];

  export default {
    data() {
      document.title = "保单批改";
      return {
        visibleStick: false,
        stickData: "", //粘贴数据
        minusMember: 0, //减员人数
        addMember: 0, //增员人数
        premiumChange: 0, //保费变化
        oldNumber: 0, //原在保人数
        selectedRowKeys: [],
        columns,
        form: this.$form.createForm(this),
        formItemLayout: {
          labelCol: {
            span: 8
          },
          wrapperCol: {
            span: 14
          },
        },
        idTypeOptions: dictOptions.gdIdTypeOptions1,
        data: [],
        prevData: [], //上一次操作后的data
        pagination: {
          total: 0,
          pageSize: 20,
          pageNum: 1,
        },
        formVisible: false,
        dateFormat: "YYYY-MM-DD",
        name: '',
        idNumber: '',
        idType: '',
        birthDate: '',
        nowdata: {}, //接口原始保单数据
        genderOptions: dictOptions.sexOptions,
        minAge: '', //当前产品计划后台配置最小可投保年龄
        maxAge: '', //当前产品计划后台配置最大可投保年龄
        operateType: '',
        operateTypeOptions: [{
            name: '批增',
            value: '01'
          },
          {
            name: '批减',
            value: '00'
          },
        ],
        ifDataChange: false, //当前数据是否有变化,
        policyId: '',
        ifEditable: true //当前保单是否可批改
      };
    },
    watch: {
      newdata: {
        handler(nowdata, olddata) {
          this.prevData = olddata
          this.pagination.total = nowdata.length
          console.log(this.nowdata.policyInsuredList, nowdata, '数据对比')
          if (this.equalsObj(this.nowdata.policyInsuredList, nowdata)) {
            this.ifDataChange = false
            this.operateType = ''
            this.premiumChange = 0
            this.minusMember = 0
            this.addMember = 0
          } else {
            if (this.data.filter(item => item.operateType === '00').length > 0) {
              this.minusMember = this.data.filter(item => item.operateType === '00').length
              this.addMember = 0
            } else if (this.data.filter(item => item.operateType === '01').length > 0) {
              this.addMember = this.data.filter(item => item.operateType === '01').length
              this.minusMember = 0
            } else {
              this.addMember = 0
              this.minusMember = 0
              this.operateType = ''
            }
            this.ifDataChange = true
            this.startCountPremium()
          }
        },
        deep: true
      },
    },
    computed: {
      newdata() {
        this.data.map((item, index) => {
          item.key = index
        })
        return JSON.parse(JSON.stringify(this.data))
      }
    },
    filters: {
      filters(val, data) {
        if (!val) {
          return;
        }
        if (!val || val === '' || val === undefined) {
          return ''
        } else {
          let Name = ''
          data.map(item => {
            if (item.value == val) {
              Name = item.name
            }
          })
          return Name
        }
      }
    },
    mounted() {
      this.nowdata = JSON.parse(localStorage.getItem('correctData'))
      if (moment().isBefore(this.nowdata.policyInfo.effectiveDate)) {
        this.ifEditable = true
      } else {
        this.ifEditable = false
      }
      this.nowdata.policyInsuredList = this.nowdata.policyInsuredList.map((item, index) => {
        item.key = index
        item.ifLocal = 'Y'
        item.idcardInvalid = false
        return item
      })
      console.log(this.nowdata, 'this.nowdata')
      this.policyId = this.nowdata.policyInfo.id
      this.getPolicyPlan();
      this.data = JSON.parse(localStorage.getItem('correctData')).policyInsuredList.map((item, index) => {
        item.key = index
        item.ifLocal = 'Y'
        item.idcardInvalid = false
        return item
      })
      this.oldNumber = this.nowdata.policyInsuredList.length
      this.pagination.total = this.data.length
    },
    methods: {
      moment,
      equalsObj(oldData, newData) { //比较数组是否完全相等

        // 类型为基本类型时,如果相同,则返回true
        if (oldData === newData) return true;
        if (this.isArray(oldData) && this.isArray(oldData) && oldData.length === newData.length) {
          // 类型为数组并且数组长度相同

          for (let i = 0, length = oldData.length; i < length; i++) {
            if (!this.equalsObj(oldData[i], newData[i]))
              // 如果数组元素中具有不相同元素,返回false
              return false;
          }
        } else {
          // 其它类型,均返回false
          return false;
        }

        // 走到这里,说明数组或者对象中所有元素都相同,返回true
        return true;
      },
      isArray(arr) {
        return Object.prototype.toString.call(arr) === '[object Array]';
      },
      getPolicyPlan() {
        api.getPolicyPlangd({
          productCode: this.nowdata.policyInfo.productCode
        }).then(res => {
          if (res.data.returnCode == '00') {
            let item = res.data.planList.filter(item => item.code === this.nowdata.policyInfo.planCode)[0]
            if (item.maxAge && item.maxAge != '') {
              if (item.maxAge.indexOf('d') > -1) {
                this.minAge = moment().subtract(parseInt(item.maxAge), 'days')
              } else if (item.maxAge.indexOf('m') > -1) {
                this.minAge = moment().subtract(parseInt(item.maxAge), 'months')
              } else if (item.maxAge.indexOf('y') > -1) {
                this.minAge = moment().subtract(parseInt(item.maxAge), 'years')
              }
            }
            if (item.minAge && item.minAge != '') {
              if (item.minAge.indexOf('d') > -1) {
                this.maxAge = moment().subtract(parseInt(item.minAge), 'days')
              } else if (item.minAge.indexOf('m') > -1) {
                this.maxAge = moment().subtract(parseInt(item.minAge), 'months')
              } else if (item.minAge.indexOf('y') > -1) {
                this.maxAge = moment().subtract(parseInt(item.minAge), 'years')
              }
            }
          }
        })
      },
      handleStick(type) {
        console.log(type, 'type')
        if (this.operateType != '' && type != this.operateType) {
          let operateName = type === '00' ? '批减' : '批增'
          this.$message.warning("当前操作存在冲突，不能再进行" + operateName + "操作");
        } else {
          //河洛欧	居民身份证	342221199110124578	1991-10-12	男	其他
          let str = this.stickData.split("\n");
          let valsArr; //返回被保人信息的数组
          console.log(
            "返回所有被保人的数组--》str",
            str,
            "单行数据valsArr",
            valsArr
          );

          let length = this.data.length;
          let append = (num) => {
            //自定义append()处理字符串函数
            const key = num + length + 1;
            let name = "";
            let birthDate = null;
            let idType = "";
            let idNumber = "";
            let mobile = "";
            let gender = "";
            let relationship = "99";
            let purchaseNumber = "";

            const len = valsArr.length;

            let chinaNames = [];
            let birthDateArr = [];
            let idCardArr = [];
            let mobileArr = [];
            let numCardArr = [];
            let birthDateIndex;
            valsArr.forEach((item, index) => {
              if (/[^\x00-\x80]/g.test(item)) {
                if (
                  [
                    "居民身份证",
                    "居民户口簿",
                    "出生证",
                    "外国护照",
                    "台湾居民往来大陆通行证",
                    "港澳居民往来内地通行证",
                  ].indexOf(item) > -1
                ) {
                  idType = this.filterIdType(item);
                } else if (["男", "女"].indexOf(item) > -1) {
                  gender = this.filterSex(item);
                } else {
                  chinaNames.push(item);
                }
              } else if (
                /\d{4}-\d{2}-\d{2}/.test(item) ||
                /\d{4}\/\d{2}\/\d{2}/.test(item)
              ) {
                if (index == 3) {
                  birthDate = moment(item);
                  birthDateIndex = index;
                }
              } else if (/\d+/.test(item)) {
                // debugger;
                let len = item.length;
                if (len === 18 && !idNumber) {
                  // idType = "1";
                  idNumber = item;
                  const result = this.calcBGByIdCardNumber(item);
                  gender = result.sex;
                  birthDate = moment(result.birth);
                } else if (len === 11 && !mobile) {
                  mobile = item;
                } else if (!idNumber) {
                  // idType = "3";
                  idNumber = item;
                } else if (len === 1 || (len === 2 && !purchaseNumber)) {
                  purchaseNumber = item;
                }
              }
            });
            if (chinaNames.length > 0) {
              // 中英文都有
              name = chinaNames[0];
              // if (enNames.length < 1) {
              //   insEnName = pinyin.getFullChars(name);
              // }
            }
            console.log(valsArr, "解析的数据 -> ");

            const item = {
              key,
              id: key,
              beneficialType: "1",
              name,
              idType,
              idNumber,
              birthDate: birthDate || null,
              gender,
              mobile,
              purchaseNumber,
              relationship: "99",
              operateType: type //批改类型
            };
            if (item.idType == "1" && !checkIdCard(item.idNumber)) {
              item.idcardInvalid = true;
            }
            console.log(item, "resolve item -> ");

            const stickPass = this.stickValidate(item);
            if (stickPass) {
              this.data.push(item); //向表格插入粘贴的数据
              this.operateType = type
              this.visibleStick = false;
            }
          };

          for (let [index, elem] of new Map(str.map((item, i) => [i, item]))) {
            valsArr = elem.split(/\s+/g);

            if (elem !== "" && valsArr.length > 0) {
              let isExist = this.data.find((item) => {
                return item.idNumber == valsArr[2];
              });
              if (type === '00') {
                let numberArr = this.data.map(item1 => {
                  return item1.idNumber
                })
                console.log(numberArr, 'numberArr----')
                let list = [...this.data]
                if (numberArr.indexOf(valsArr[2]) > -1) {
                  list[numberArr.indexOf(valsArr[2])].operateType = '00'
                  this.data = list
                } else {
                  this.$message.warning(`被保人${valsArr[0]}不存在，请检查!`);
                }

              } else {
                if (isExist && isExist.idNumber) {
                  this.$message.warning(`被保人${valsArr[0]}重复，请检查!`);
                } else {
                  append(index);
                }
              }
              this.startCountPremium();
            }
          }
          console.log(this.data, "thi.data-----粘贴");
          console.log(this.minAge, this.maxAge, "年纪范围");
          this.data.map((item) => {
            if (!moment(item.birthDate).isBetween(this.minAge, this.maxAge)) {
              item.idcardInvalid = true;
              this.$message.warning(
                `被保人${item.name}年纪不在可承保范围，请检查!`,
                6
              );
            }
          });

        }

      },
      stickValidate(item) {
        let phoneR = /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
        let isPass = true;

        //粘贴时判断证件号与性别
        const resultInfo = this.calcBGByIdCardNumber(item.idNumber);
        let birth = moment(item.birthDate).format("YYYY-MM-DD");
        if (
          (item.idType === "11" || item.idType === "12") &&
          birth !== resultInfo.birth
        ) {
          this.$message.warning(`被保人${item.name}的证件号与生日不符`, 6);
          isPass = false;
        }
        if (
          (item.idType === "11" || item.idType === "12") &&
          item.gender !== resultInfo.sex
        ) {
          this.$message.warning(`被保人${item.name}的证件号与性别不符`, 6);
          isPass = false;
        }

        //校验重复部分
        let isExist = this.data.find((ele) => {
          return item.idNumber == ele.idNumber;
        });

        let isExist1 = this.data.find((ele) => {
          return item.mobile == ele.mobile;
        });

        if (isExist && isExist.idNumber) {
          this.$message.warning(`被保人${item.name}证件号重复，请检查!`, 6);
        } else if (isExist1 && isExist1.mobile) {
          this.$message.warning(`被保人${item.name}手机号重复，请检查!`, 6);
        } else if (!phoneR.test(item.mobile)) {
          this.$message.warning(`请输入正确手机号`, 3);
          isPass = false;
        }

        return isPass;
      },
      calcBGByIdCardNumber(idNumber) {
        let year = idNumber.slice(6, 10);
        let mon = idNumber.slice(10, 12);
        let day = idNumber.slice(12, 14);
        let birth = year + "-" + mon + "-" + day;
        let sex = idNumber.slice(16, 17) % 2 == 1 ? "M" : "F";
        return {
          birth,
          sex,
        };
      },
      onSelectChange(selectedRowKeys) {
        console.log(selectedRowKeys, 'selectedRowKey---->')
        this.selectedRowKeys = selectedRowKeys;
      },
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log("Received values of form: ", values);
            this.data.push({
              ...values,
              birthDate: moment(values.birthDate).format("YYYY-MM-DD"),
              operateType: '01',
              beneficialType: "1",
              relationship: "99",
              salBeneficiaries: [],
              idcardInvalid: false,
            });
            this.formVisible = false;
            this.operateType = '01'
          }
        });
      },
      cancelAdd() {
        //取消新增
        let data = this.data;
        let isExit = data.find((item) => {
          return item.operateType == "01";
        });
        if (!isExit) {
          this.$message.warning("您暂时没有新增被保人");
          return;
        } else {
          data.map((item, index) => {
            if (item.operateType == "01") {
              data.splice(index, 1);
            }
          });
          this.data = [...data];
        }
      },
      AddOne() {
        if (this.operateType === '00') {
          this.$message.warning("当前操作存在批减，不能再进行增加操作");
        } else {
          this.formVisible = true;
        }
      },
      deleteSelect() {
        if (this.data.length < 2) {
          this.$message.warning("被保人最少一个，不能进行删除操作");
        } else {
          if (this.operateType === '01' && !this.ifDataChange) {
            this.$message.warning("当前操作存在批增，不能再进行减少操作");
          } else if (this.operateType === '01' && this.ifDataChange) {
            let newselectKey = []
            this.selectedRowKeys.map(item => {
              if (!this.data[item].ifLocal) {
                newselectKey.push(item)
              }
            })
            if (newselectKey.length === 0) {
              this.$message.warning("当前操作存在批增，不能再进行减少操作");
            } else {
              newselectKey.map(item => {
                this.data.splice(item, 1);
              })
            }
          } else if (this.operateType != '01') {
            let list = [...this.data]
            this.selectedRowKeys.map(item => {
              list[item].operateType = '00'
            })
            this.data = list
            this.operateType = '00'
          }
        }
        this.selectedRowKeys = []
      },
      cancelDelete() {
        this.data = this.prevData
      },
      restore() {
        this.data = JSON.parse(localStorage.getItem('correctData')).policyInsuredList
      },
      handleOk(e) {
        console.log(e);
        this.formVisible = false;
      },
      handleTypeChange(value, option) {
        console.log(value, option, '----')
        this.idType = value
      },
      searchData() {},
      reback() {
        this.$router.go(-1);
      },
      handlePageChange(e) {
        this.pageNum = e.current;
        this.initData();
      },
      filterSex(val) {
        return val == "男" ? "M" : "F";
      },
      filterIdType(val) {
        //身份类型过滤
        let v = "";
        this.idTypeOptions.map((item) => {
          if (item.name == val) {
            v = item.value;
          }
        });
        return v;
      },
      filterRelation: (val) => {
        //关系过滤
        if (val == "本人") {
          return "00";
        } else if (val == "配偶") {
          return "01";
        } else if (val == "子女") {
          return "03";
        } else if (val == "父母") {
          return "02";
        } else if (val == "其他") {
          return "99";
        }
      },
      handledisabledDate(currentDate) {
        return this.minAge === '' ? false : currentDate && (currentDate < this.minAge || currentDate > this.maxAge)
      },
      beforeUpload(file, fileList) {
        console.log(file, fileList, 'info-----')
        if (fileList != undefined) {
          const formData = new FormData();
          formData.append('file', file);
          api.uploadFileForInsureds(formData).then(res => {
            if (res.data.returnCode === '00') {
              let length = this.data.length;
              let hasInvalidIdCard = false;
              if (this.checkData(res.data.content)) {
                res.data.content.forEach((item, index) => {
                  let obj = {
                    beneficialType: "1",
                    name: item.name,
                    idType: item.idType,
                    idNumber: item.idNumber,
                    gender: this.filterSex(item.gender),
                    mobile: item.mobile,
                    birthDate: item.birthDate,
                    relationship: item.raletionShip,
                    purchaseNumber: item.purchaseNumber,
                    operateType: "01",
                    salBeneficiaries: [],
                  };
                  if (obj.idType == "11" && !checkIdCard(obj.idNumber)) {
                    obj.idcardInvalid = true;
                    hasInvalidIdCard = true;
                  }
                  this.data.push(obj);
                });
                this.operateType = "01"
                console.log(this.data, 'this.data---->导入')
                if (hasInvalidIdCard) {
                  this.$message.error("有被保险人居民身份证输入有误，请修改！", 3);
                }
                this.data.map(item => {
                  if (!moment(item.birthDate).isBetween(this.minAge, this.maxAge)) {
                    item.idcardInvalid = true
                    this.$message.warning(`被保人年纪不在可承保范围，请检查!`);
                  }
                })
              }
            }
          })
        }
      },
      beforeUpload1(file, fileList) {
        if (fileList != undefined) {
          const formData = new FormData();
          formData.append('file', file);
          api.descInsuredSingle({
            policyId: this.policyId
          }, formData).then(res => {
            if (res.data.returnCode === '00') {
              let numberArr = []
              res.data.content.map(item => {
                numberArr.push(item.idNumber)
              })
              let list = []
              this.data.map((item, index) => {
                if (numberArr.indexOf(item.idNumber) > -1) {
                  item.operateType = '00'
                }
                list.push(item)
              })
              this.data = list
              this.operateType = '00'
            }
          })
        }
      },
      checkData(objArr) {
        let idNumArr = []
        if (this.data.length > 0) {
          this.data.map(item => {
            idNumArr.push(item.idNumber)
          })
          if (objArr.length > 0) {
            for (let i = 0; i < objArr.length; i++) {
              if (idNumArr.indexOf(objArr[i].idNumber) > -1) {
                this.$message.error("被保险人" + objArr[i].name + "数据重复，请修改！", 3);
                return false
                break
              } else {
                return true
              }
            }
          }
        } else {
          return true
        }
      },
      handleDateChange(date, dateString) {
        console.log(date, dateString)
        let _this = this
        let idNumber = this.form.getFieldValue('idNumber')
        if (checkIdCard(idNumber) && (this.idType === "11" || this.idType === "12")) {
          let result = this.calcBGByIdCardNumber(idNumber);
          if (dateString !== result.birth) {
            this.$message.warning('生日与证件号不符', 3)
            let st = setTimeout(() => {
              _this.form.setFieldsValue({
                birthDate: moment(result.birth)
              })
            }, 100);
            console.log(moment(result.birth))
          }
        }
      },
      genderChange(val) {
        let idNumber = this.form.getFieldValue('idNumber')
        let _this = this
        console.log(val, idNumber)
        if (checkIdCard(idNumber) && (this.idType === "11" || this.idType === "12")) {
          let result = this.calcBGByIdCardNumber(idNumber);
          if (val !== result.sex) {
            this.$message.warning('性别与证件号不符', 3)
            let st = setTimeout(() => {
              _this.form.setFieldsValue({
                gender: result.sex
              })
            }, 100);

          }
        }
      },
      mobileChange(val) {
        let phoneR = /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
        if (val && !phoneR.test(val)) {
          this.$message.warning('请输入正确手机号', 3)
          this.form.setFieldsValue({
            mobile: ''
          })
        }
      },
      validate(value) {
        // 校验被保人证件号码
        var regIdCard =
          /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
        let result = {}
        if (!checkIdCard(value) && (this.idType === "11" || this.idType === '12')) {
          this.$message.warning("请输入正确的证件号", 3);
          this.form.setFieldsValue({
            idNumber: ''
          })
        } else if (checkIdCard(value) && this.idType === "11") {
          result = this.calcBGByIdCardNumber(value);
          if (!moment(result.birth).isBetween(this.minAge, this.maxAge)) {
            this.$message.warning(`被保人年纪不在可承保范围，请检查!`);
          } else {
            this.form.setFieldsValue({
              birthDate: moment(result.birth)
            })
            this.form.setFieldsValue({
              gender: result.sex
            })
          }
        } else if (checkIdCard(value) && this.idType === "12") {
          result = this.calcBGByIdCardNumber(value);
          this.form.setFieldsValue({
            birthDate: moment(result.birth)
          })
          this.form.setFieldsValue({
            gender: result.sex
          })
        } else if (this.idType === '17' || this.idType === '24') {
          if (value.length < 3) {
            this.$message.warning("请输入完整的证件号", 3);
            this.form.setFieldsValue({
              idNumber: ''
            })
          }
        } else {
          if (value.length < 8) {
            this.$message.warning("请输入完整的证件号", 3);
            this.form.setFieldsValue({
              idNumber: ''
            })
          }
        }
      },
      judgeAge(birthDate) {
        let m18 = moment().subtract(18, "year");
        let adult = false
        if (this.minAge === '' || this.maxAge === '') {
          adult = true
        } else {
          adult = moment(birthDate).isBetween(this.minAge, this.maxAge);
        }
        return adult;
      },
      showStickMask() {
        this.visibleStick = true;
        this.stickData = '';
      },
      startCountPremium() {
        console.log(this.data, this.nowdata, this.operateType, '开始计算保费变化')
        let params = []
        if (this.minusMember > 0) { //判断当前数据为在原有数据基础上删减后的数据
          let money = 0
          this.data.map(item => {
            if (item.operateType && item.operateType === '00') {
              money += parseFloat(item.premium)
            }
          })
          this.premiumChange = parseFloat(money).toFixed(2)
        } else {
          this.data.map(item => {
            if (!item.ifLocal) {
              let paramsitem = {
                productCode: this.nowdata.policyInfo.productCode,
                planCode: this.nowdata.policyInfo.planCode,
                effectiveDate: this.nowdata.policyInfo.effectiveDate.substring(0, 10),
                expireDate: this.nowdata.policyInfo.expireDate.substring(0, 10),
                birthDate: item.birthDate,
                purchaseNumber: item.purchaseNumber
              }
              params.push(paramsitem)
            }
          })
          console.log(this.data, params, 'this.params--->')
          let diffLength = this.data.length - params.length
          api.calPremiumGd(params).then(res => {
            if (res.data.returnCode == '00') {
              this.premiumList = res.data.premiumList;
              this.premiumChange = res.data.content
              if (diffLength === 0) {
                this.data.map((item, index) => {
                  item.premium = res.data.premiumList[index].premium
                })
              } else {
                this.data.map((item, index) => {
                  if (index > diffLength - 1) {
                    item.premium = res.data.premiumList[index - diffLength].premium
                  }
                })
              }
            }
          })
        }
      },
       addPremium() {
      let arr = [];
      this.postChange.policyInsuredVoList.map((item) => {
        if (!this.premiumList) {
          return;
        }

        let a = this.premiumList;
        for (let i = 0; i < a.length; i++) {
          if (item.idNumber == a[i]["idNumber"]) {
            arr.push({
              ...item,
              planCode: a[i]["planCode"],
              premium: a[i]["premium"],
             amount: a[i]["amount"],
            });
            break;
          }
        }
      });
      this.postChange.policyInsuredVoList = arr;
    },
      saveChange() {
        this.postChange = {
          flag: '1',
          operateType: this.operateType,
          orderType: '1',
          policyInfo: this.nowdata.policyInfo,
        }
        let insuredVoList = []
        let checkArr = this.data.map(item => {
          return item.idcardInvalid
        })
        if (checkArr.indexOf(true) > -1) {
          this.$message.warning('被保人' + this.data[checkArr.indexOf(true)].name + '不在可承保范围内，请检查');
          return
        } else {
          this.data.map(item => {
            if (item.operateType) {
              let pitem = {
                ...item,
                planCode: this.nowdata.policyInfo.planCode,
              }
              insuredVoList.push(pitem)
              delete item.operateType
            }
            delete item.key
            delete item.idcardInvalid
            if (item.ifLocal) {
              delete item.ifLocal
            }
          })
        }
        this.postChange = {
          ...this.postChange,
          policyInsuredVoList: insuredVoList
        }

        if(this.premiumList.length != 0){
         this.addPremium()
        }

        api.changeOrder(this.postChange).then(res => {
          if (res.data.returnCode === '00') {
            this.$message.info('批改成功', 3);
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.returnMsg, 3);
            this.checkError(res.data.content)
          }
        })
      },
      checkError(list) {
      const data = this.data;
      if (list) {
        data.map((item) => {
          list.map((ele) => {
            if (ele.idNumber == item.idNumber) {
              item.sexErr = ele.sexErr;
              item.idcardInvalid = ele.idErr;
            }
          });
        });
      }
      this.data = [...data];
    },
    },
  };
</script>
<style lang="scss" scoped>
  .min_input_ {
    width: 64px;
  }

  .span_btn {
    a {
      color: #ff4c1c;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .fixbg_ {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
    background-color: rgba(0, 0, 0, 0.3);
    height: 100vh;

    .fixcon {
      background-color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 960px;
      margin: 0 auto;
      max-height: 50vh;
      overflow-y: hidden;
      padding-top: 50px;
      top: 50%;
      transform: translateY(-50%);

      &>p {
        font-weight: bold;
        font-size: 16px;
        height: 50px;
        line-height: 50px;
        margin: 0;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        margin: 0 auto;
        padding: 0 20px;
      }

      .close_ {
        width: 30px;
        height: 30px;
        background: url(../../../assets/wxmall/closeicon.png) center center no-repeat;
        background-size: 30px 30px;
        position: absolute;
        right: 20px;
        top: 10px;
        cursor: pointer;
      }

      .detail {
        position: absolute;
        left: 0;
        right: 0;
        padding: 0 20px;
        bottom: 50px;
        top: 50px;
        overflow-y: scroll;

        &>p {
          font-weight: bold;
        }
      }

      .forminfo_ {
        display: flex;
        flex-direction: row;

        .infoitem {
          display: flex;
          flex: 1;
          margin-bottom: 20px;

          input {
            border: 1px solid #d9d9d9;
            background-color: transparent;
            width: 95px;
            padding-left: 5px;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
          }

          select {
            width: 100px;
            height: 32px;
            line-height: 32px;
            border-radius: 4px;
            border: 1px solid #d9d9d9;
          }

          span {
            white-space: nowrap;
            margin-right: 5px;
            width: 65px;
            text-align: left;
            height: 30px;
            line-height: 30px;
          }
        }
      }

      .btn_b {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 50px;
        padding-bottom: 10px;
        display: flex;
        justify-content: center;

        button {
          width: 100px;
          height: 40px;
          line-height: 40px;
          background-color: #ff4c1c;
          color: #fff;
          text-align: center;
          border: none;
          outline: none;
          border-radius: 4px;
          display: block;
          font-size: 16px;
          padding: 0;
          cursor: pointer;

          &:first-child {
            margin-right: 40px;
          }
        }
      }
    }
  }

  .itemright {
    position: relative;
  }

  .selectmask {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 5;
    left: 0;
    right: 0;
    background-color: transparent;
    width: 100% !important;
  }

  .table_b {
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .foot_ {
    .left_ {
      a {
        margin-right: 10px;

        img {
          height: 16px;
          width: auto;
          margin: 0 5px 3px 0;
        }

        span {
          font-size: 14px;
          color: rgba(0, 0, 0, 1);
        }
      }
    }

    .pagina_ {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .li_v_ {
        width: 1px;
        height: 18px;
        border: 1px solid rgba(153, 153, 153, 1);
        opacity: 0.2;
        margin: 0 19px;
      }

      .total_ {
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
      }
    }
  }

  .modify_ {
    background: rgba(244, 244, 244, 1);
    padding: 20px;

    .mo_con_ {
      max-width: 1350px;
      background: #fff;
      margin: 0 auto;

      .title_ {
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        font-family: Microsoft YaHei UI;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        background: linear-gradient(90deg,
            rgba(248, 248, 248, 1) 0%,
            rgba(255, 255, 255, 1) 100%);
        padding-left: 20px;
        position: relative;
      }

      .title_::before {
        position: absolute;
        top: 14px;
        left: 10px;
        content: "";
        width: 3px;
        height: 17px;
        background: rgba(244, 85, 15, 1);
        border-radius: 2px;
      }

      .gdMange_ {
        padding: 0 45px 45px 45px;
      }
    }
  }

  .footer_ {
    margin: 40px 0;
    color: #333333;
  }

  .tip_ {
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    margin: 16px 0;
  }

  .theme_ {
    color: #f5692c !important;
  }

  .btn_upload {
    color: #F5692C;
    width: 88px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #F5692C;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    margin-left: 8px;
  }

  .btn_model {
    color: #fff;
    width: 64px;
    height: 32px;
    line-height: 32px;
    background-color: #F5692C;
    border-color: #F5692C;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: absolute;
    right: 370px;
    bottom: 40px;
  }
</style>